module.exports = __webpack_public_path__ + "img/query.7fa20c80.svg";